var r = Object.defineProperty;
var a = (n, e, t) => e in n ? r(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var i = (n, e, t) => a(n, typeof e != "symbol" ? e + "" : e, t);
import { HttpClient as o, httpClient as s } from "../../httpClient.js";
class u extends o {
  constructor() {
    super(...arguments);
    i(this, "endpoint", "/quizzes");
  }
  async getAll(t) {
    return s.get(this.endpoint, { params: t });
  }
  async start(t) {
    return s.post(this.endpoint, { courseId: t });
  }
  async update(t, p) {
    return s.put(`${this.endpoint}/${t}`, p);
  }
  async deleteByCourse(t) {
    return s.delete(this.endpoint, { params: { courseId: t } });
  }
}
const c = new u();
export {
  c as default
};
